module.exports = __webpack_public_path__ + "img/v-sport-jdb-s-min.de696788.png";